import React, { useEffect, useState } from "react";
import "../../../AccountAttributes/List/AccountList.css";
import "../../../Dashboard/Sidebar";
// import ReactPaginate from 'react-paginate';
import Header from "../../../layout/header";
// import BottomMenu from "../../../layout/bottomMenu";
import DashboardMenu from "../../../layout/dashboardMenu";
import Loader from "../../../../Loader/Loader";
import NotFoundData from "../../../../Images/no-data-found.webp";
import Moment from "moment/moment";
import ReactPaginate from "react-paginate";
import '../../../main_2.css'

const Sites = ({ 
  getExistingSites, 
  existingSiteDetails = [], 
  isUserCheckInForModule, 
  userCheckInForModule = [], 
  match }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [roleId, setRoleId] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    (async () => {
      let roleId = localStorage.getItem("role_id");
      setRoleId(roleId);
      setIsLoading(true);
      await getExistingSites(pageNo);
      setIsLoading(false);
    })();
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    setPage(val?.selected + 1);
    await getExistingSites(val?.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await isUserCheckInForModule('valet', null, null, true);
      setIsLoading(false);
    })();
  }, []);
  

  const handleSearch = async () => {
    if (searchValue === "") {
      return false;
    }

    window.localStorage.search_account = searchValue
    setIsLoading(true);
    await getExistingSites(pageNo, searchValue);
    setIsLoading(false);
  };

  const removeSearchFilter = async () => {
    delete window.localStorage.search_account
    setIsLoading(true)
    await getExistingSites(pageNo)
    setIsLoading(false)
  }

  return (
    <>
      {/*<Sidebar/>*/}
      {/* section start  */}
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Sites List"} />
            {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="row b-13"></div>
                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                  <div className="row col-md-12">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                      <form className="form-inline mr-auto w-100 navbar-search">
                        <div className="d-flex w-100">
                          <input
                            type="text"
                            className="form-control bg-light border-0 small list-filter"
                            placeholder={
                              isGlobalSearch
                                ? "Search Site globally.."
                                : "Search Site..."
                            }
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                          />
                          <div className="remove-search-filter">
                            <i className="fa fa-times" aria-hidden="true" onClick={removeSearchFilter}></i>
                          </div>
                          <div className="btn-search">
                            <button
                              className="btn btn-primary lh-32 border-left-tr-tb"
                              type="button"
                              onClick={(e) => handleSearch()}
                            >
                              <i className="fas fa-search fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                      {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* {console.log("Check PI:", userCheckInForModule)} */}
                  {/*CARD START*/}
                  {existingSiteDetails &&
                    existingSiteDetails?.data !== undefined &&
                    existingSiteDetails?.data?.resultSets !== undefined &&
                    existingSiteDetails?.data !== {} &&
                    existingSiteDetails?.data?.resultSets.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"
                              >
                                <div className="content">
                                  <h6 className="category mrg-b-12">
                                    <div className="row"></div>
                                    <div className="d-flex">
                                      <p>{val?.project_name}</p>
                                    </div>
                                    <div className="row list-view">
                                      {val?.project_id !== undefined &&
                                        val?.project_id !== null && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i
                                                className="fa fa-map"
                                                aria-hidden="true"
                                              ></i>
                                              &nbsp;&nbsp;Project Id
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.project_id}
                                            </div>
                                          </div>
                                        )}
                                      {val?.latitude !== undefined &&
                                        val?.latitude !== null && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                              ></i>
                                              &nbsp;&nbsp;Latitude
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.latitude}
                                            </div>
                                          </div>
                                        )}
                                      {val?.longitude !== undefined &&
                                        val?.longitude !== null && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                              ></i>
                                              &nbsp;&nbsp;Longitude
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.longitude}
                                            </div>
                                          </div>
                                        )}
                                      {val?.status !== undefined &&
                                        val?.status !== null && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="bi bi-map"></i>
                                              &nbsp;&nbsp;Status
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.status}
                                            </div>
                                          </div>
                                        )}
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="fas fa-calendar-alt"></i>
                                          &nbsp;&nbsp;Onboarding Date
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={Moment(
                                              val?.onboarding_date
                                            ).format("DD-MM-YYYY")}
                                          >
                                            {Moment(
                                              val?.onboarding_date
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    <div
                                      className="row list-view-links"
                                      style={{ padding: "12px" }}
                                    >

                                    <ul>
                                        <li style={{ margin: "-8px" }}>
                                          <a href={`site-visit-list/${val?.project_id}`}>
                                            <i className="bi bi-list"></i>
                                            &nbsp;&nbsp;View List
                                          </a>
                                        </li>
                                      {(val?.project_id === userCheckInForModule?.valet_project_id) && (
                                        <li style={{ margin: "-8px" }}>
                                          <a href={`site-visit/${val?.project_id}`}>
                                            <i className="bi bi-list"></i>
                                            &nbsp;&nbsp;Complete meeting
                                          </a>
                                        </li>
                                      )}
                                      {!(val?.project_id === userCheckInForModule?.valet_project_id) && (
                                        <li style={{ margin: "-8px" }}>
                                          <a href={`create-meeting/${val?.project_id}`}>
                                            <i className="bi bi-list"></i>
                                            &nbsp;&nbsp;Create meeting
                                          </a>
                                        </li>
                                      )}
                                    </ul>

                                    </div>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}

                  {existingSiteDetails &&
                    existingSiteDetails?.data !== undefined &&
                    existingSiteDetails?.data?.resultSets !== undefined &&
                    existingSiteDetails?.data?.resultSets.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={
                            existingSiteDetails?.data?.total /
                            existingSiteDetails?.data?.per_page
                          }
                          forcePage={
                            existingSiteDetails?.data?.current_page - 1
                          }
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}

                  {existingSiteDetails &&
                    existingSiteDetails?.data !== undefined &&
                    existingSiteDetails?.data?.resultSets !== undefined &&
                    existingSiteDetails?.data?.resultSets.length === 0 && (
                      <>
                        <img src={NotFoundData} className="not-found-data" />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                      </>
                    )}
                  {/*PAGINATION END*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section ends */}
    </>
  );
};

export default Sites;
